import RemoveLiquidity from 'views/RemoveLiquidity'

export default RemoveLiquidity